import React from "react";
import { Card, CardBody, Flex, Icon, Skeleton, Stat, StatHelpText, StatLabel, StatNumber, Tooltip } from "@chakra-ui/react";

const KpiCard = ({ label, value, helperText, icon, isLoading, tooltip }) => {
  const cardContent = (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardBody>
        {isLoading ? (
          <Skeleton height="56px" />
        ) : (
          <Flex align="center" gap={3}>
            {icon ? <Icon as={icon} boxSize={6} color="blue.500" /> : null}
            <Stat>
              <StatLabel>{label}</StatLabel>
              <StatNumber>{value}</StatNumber>
              {helperText ? <StatHelpText>{helperText}</StatHelpText> : null}
            </Stat>
          </Flex>
        )}
      </CardBody>
    </Card>
  );

  if (!tooltip) {
    return cardContent;
  }

  return (
    <Tooltip label={tooltip} hasArrow>
      {cardContent}
    </Tooltip>
  );
};

export default KpiCard;
